import { CollaboratorsPurchaseRequest } from '../../models/purchase/collaborators-purchase-request.model';
import { CreatePurchaseRequest } from '../../models/purchase/create-purchase-request.model';
import { PaymentPurchaseRequest } from '../../models/purchase/payment-purchase-request.model';
import { PurchaseSummary } from '../../models/purchase/summary-purchase.model';
import { ValuesPurchaseRequest } from '../../models/purchase/values-purchase-request.model';
import {
    ADD_COLLABORATOR_PURCHASE,
    ADD_COLLABORATOR_PURCHASE_ERROR,
    ADD_COLLABORATOR_PURCHASE_SUCCESS,
    CREATE_PURCHASE, CREATE_PURCHASE_ERROR, CREATE_PURCHASE_SUCCESS, GET_PURCHASE_SUMMARY, GET_PURCHASE_SUMMARY_ERROR, GET_PURCHASE_SUMMARY_SUCCESS, PAYMENT_PURCHASE, PAYMENT_PURCHASE_ERROR, PAYMENT_PURCHASE_SUCCESS, RESET_PURCHASE, RESET_PURCHASE_ERROR, RESET_PURCHASE_SUCCESS, UPDATE_VALUES_PURCHASE, UPDATE_VALUES_PURCHASE_ERROR, UPDATE_VALUES_PURCHASE_SUCCESS
} from '../contants';

export const resetPurchase = () => ({
  type: RESET_PURCHASE,
  payload: null,
});

export const resetPurchaseSuccess = () => ({
  type: RESET_PURCHASE_SUCCESS,
  payload: null,
});

export const resetPurchaseError = (message: any) => ({
  type: RESET_PURCHASE_ERROR,
  payload: { message },
});

export const createPurchase = (assignorGuid: string, managerGuid: string, createPurchase: CreatePurchaseRequest) => ({
  type: CREATE_PURCHASE,
  payload: { assignorGuid, managerGuid, createPurchase },
});

export const createPurchaseSuccess = (response: number) => ({
  type: CREATE_PURCHASE_SUCCESS,
  payload: response,
});

export const createPurchaseError = (message: any) => ({
  type: CREATE_PURCHASE_ERROR,
  payload: { message },
});

export const addCollaboratorsPurchase = (assignorGuid: string, managerGuid: string, collaboratorsPurchase: CollaboratorsPurchaseRequest) => ({
  type: ADD_COLLABORATOR_PURCHASE,
  payload: { assignorGuid, managerGuid, collaboratorsPurchase },
});

export const addCollaboratorsPurchaseSuccess = (response: boolean) => ({
  type: ADD_COLLABORATOR_PURCHASE_SUCCESS,
  payload: response,
});

export const addCollaboratorsPurchaseError = (message: any) => ({
  type: ADD_COLLABORATOR_PURCHASE_ERROR,
  payload: { message },
});

export const updateValuesPurchase = (assignorGuid: string, managerGuid: string, valuesPurchase: ValuesPurchaseRequest) => ({
  type: UPDATE_VALUES_PURCHASE,
  payload: { assignorGuid, managerGuid, valuesPurchase },
});

export const updateValuesPurchaseSuccess = (response: any) => ({
  type: UPDATE_VALUES_PURCHASE_SUCCESS,
  payload: response,
});

export const updateValuesPurchaseError = (message: any) => ({
  type: UPDATE_VALUES_PURCHASE_ERROR,
  payload: { message },
});

export const getPurchaseSummary = (assignorGuid: string, managerGuid: string, purchaseId: number, productId: number = 0, oldValue: number = 0, newValue: number = 0, purchaseSummary?: any) => ({
  type: GET_PURCHASE_SUMMARY,
  payload: { assignorGuid, managerGuid, purchaseId, productId, oldValue, newValue, purchaseSummary },
});

export const getPurchaseSummarySuccess = (response: PurchaseSummary) => ({
  type: GET_PURCHASE_SUMMARY_SUCCESS,
  payload: response,
});

export const getPurchaseSummaryError = (message: any) => ({
  type: GET_PURCHASE_SUMMARY_ERROR,
  payload: { message },
});

export const paymentPurchase = (assignorGuid: string, managerGuid: string, purchaseId: number, paymentPurchase: PaymentPurchaseRequest) => ({
  type: PAYMENT_PURCHASE,
  payload: { assignorGuid, managerGuid, purchaseId, paymentPurchase },
});

export const paymentPurchaseSuccess = (response: any) => ({
  type: PAYMENT_PURCHASE_SUCCESS,
  payload: response,
});

export const paymentPurchaseError = (message: any) => ({
  type: PAYMENT_PURCHASE_ERROR,
  payload: { message },
});
